import { CheckCatalogButton, Image } from 'app/src/shared/components'
import successImage from 'app/static/images/success_img.png'
import { useTranslation } from 'react-i18next'

export function RefundSuccess() {
  const { t } = useTranslation('shopping', { keyPrefix: 'Refund' })

  return (
    <div className='mt-2 flex'>
      <div className='mx-auto'>
        <div
          className='mx-auto my-4 text-center text-[28px] font-bold'
          dangerouslySetInnerHTML={{ __html: t('Funnel.Steps.SuccessStep.trailer') }}
        />

        <Image
          pt={{ image: { className: 'object-fit mx-auto h-[150px] lg:h-[250px]' } }}
          src={successImage}
          alt='Immagine di successo della richiesta di rimborso'
        />
        <div
          className='mx-auto my-4 text-center text-[18px]'
          dangerouslySetInnerHTML={{ __html: t('Funnel.Steps.SuccessStep.footer') }}
        />

        <div className='mx-auto flex justify-center'>
          <CheckCatalogButton />
        </div>
      </div>
    </div>
  )
}
